import i18next from "i18next";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFlightsMiniInfo } from "../../../info/allFlights";
import {
  Content,
  Hero,
  HeroBadge,
  HeroSubtitle,
  HeroTitle,
  List,
  SectionTitle,
  Wrapper,
} from "./style";

export const FlightsListComponent = () => {
  const { t, language } = i18next;
  const [flights, setFlights] = useState([]);

  useEffect(() => {
    const getAllFlights = async () => {
      const flights = await getFlightsMiniInfo(0, false);
      setFlights(flights);
    };

    getAllFlights();
  }, []);

  return (
    <Wrapper>
      <Hero>
        <HeroBadge>✈ {t("all_flights")}</HeroBadge>
        <HeroTitle>{t("routes")}</HeroTitle>
        <HeroSubtitle>{t("buy_tickets_to_all_destinations")}</HeroSubtitle>
      </Hero>

      <Content>
        <SectionTitle>
          {t("routes")} ({flights.length})
        </SectionTitle>

        <List>
          {flights.map(item => {
            const destination = {
              pathname: `${item.key}`,
              state: { ...item.name },
            };
            return (
              <Link key={item.key} to={destination}>
                {item.name[language]}
              </Link>
            );
          })}
        </List>
      </Content>
    </Wrapper>
  );
};
